/** Every string the edit route adds on top of the shared editor. */
export const copy = {
  crumbs: {
    root: 'لوحة التشغيل',
    list: 'المقالات',
    current: 'تحرير',
  },

  head: {
    title: 'تحرير المقال',
    lede: 'النصّ في العمود، وضبطه في الجانب. ما تكتبه يُحفَظ كتلةً كتلة، فيخرج على صفحة المقال بالشكل الذي تراه هنا.',
  },

  stateHint: 'يراها كاتبها وحده. «ارفع للمراجعة» ينقلها إلى مراجِع — وهو من ينشرها أو يردّها، لا أنت.',
  rejectedHint: 'رُدّ إليك مع سببه. صحّح ما طُلب ثمّ ارفعه من جديد.',

  /**
   * The two states this route does not serve. A post awaiting review sits with
   * its reviewer, and editing it there changes the text under the eyes reading
   * it; a published one is managed from the post's own page.
   */
  notEditable: {
    title: 'المقال ليس في يد كاتبه الآن',
    body: 'المسوّدة والمردود وحدهما يُحرَّران. افتح صفحة المقال لتقرأه وتتصرّف فيه من هناك.',
    action: 'افتح صفحة المقال',
  },

  announce: {
    saved: 'حُفظت التغييرات.',
    submitted: 'رُفع المقال للمراجعة.',
    deleted: 'حُذف المقال نهائياً.',
  },

  states: {
    loading: 'جارٍ تحميل المقال',
  },
} as const;
